<template>
<div class="menuBody"   style="padding-left:25px;">
    <OrganizationalStructure @AllData="getMsgFormSon" style="display:none"/>
        <ChargeItemDialog :param="diaLogData" @Visible="menuTool" ref="ChargeItemDialog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
          
            <div style="border-bottom: 1px solid rgba(234, 237, 241, 1);height:40px">
            <div style="width:150px;float:left;margin-right:30px;margin-top:10px">
                收费项目列表
            </div>
            <div style="float:right">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cs:cItemS:save'" @click="PropertyAdd()">收费项目添加</el-button>
            </div>
            </div>
              <div style="width:150px;float:left;margin-top:10px">
                 <el-input placeholder="请输入项目代码" size="small"     v-model="CourseCode"></el-input>
            </div>
             <div style="width:150px;float:left;margin-left:60px;margin-top:10px">
                 <el-input placeholder="请输入项目名称" size="small"     v-model="CourseName"></el-input>
            </div>
             <div style="width:170px;float:left;margin-left:60px;margin-top:10px">
                <el-select  clearable v-model="PayItemval" placeholder="收费项目类别" @change="expend()"  size="small" >
                    <el-option v-for="item in PayItem" :key="item.PayItemval" :label="item.PayItemlab" :value="item.PayItemval"></el-option>
                </el-select>
            </div>
             <div style="float:left;margin-top:10px;margin-left:40px;">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cs:cItemS:selectListPage'" @click="Inquire()">查询</el-button>
            </div>

            <el-table  :data="tableData "   v-loading="loading" tooltip-effect="light" 
              style="overflow-y: scroll;float:right;margin-top:30px;height:475px" row-key="id" 
              :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column show-overflow-tooltip prop="feeCode" label="项目代码"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="feeName" label="项目名称" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="displayName" label="显示名称" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="feeCategory" label="收费项目类别" >
              <template slot-scope="scope">
        <el-tag v-if="scope.row.feeCategory=='01'" >日常收费</el-tag>
        <el-tag v-if="scope.row.feeCategory=='02'" >停车收费</el-tag>
        <el-tag v-if="scope.row.feeCategory=='03'" >装修收费</el-tag>
        <el-tag v-if="scope.row.feeCategory=='3'" >进户收费</el-tag>
        <el-tag v-if="scope.row.feeCategory=='04'" >代收费</el-tag>
        <el-tag v-if="scope.row.feeCategory=='05'" >代收费</el-tag>
        <el-tag v-if="scope.row.feeCategory=='06'" >其他</el-tag>
        <el-tag v-if="scope.row.feeCategory=='07'" >分等收费</el-tag>
        <el-tag v-if="scope.row.feeCategory=='08'" >押金</el-tag>
      </template>
    </el-table-column>
    <el-table-column show-overflow-tooltip prop="taxRateName" label="税额对应科目" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="remarks" label="备注信息" ></el-table-column>
    <el-table-column fixed="right" label="操作" >
     <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small" title="修改" v-Jurisdiction="'expense:web:cs:cItemS:save'" ></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small" title="删除"  v-Jurisdiction="'expense:web:cs:cItemS:delete'" v-debounce></el-button>
        </template>
    </el-table-column>
  </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import ChargeItemDialog from "../common/ChargeItemDialog";
import OrganizationalStructure from "../common/OrganizationalStructure.vue";

export default {
  name: "ChargeItemList",
  components: {ChargeItemDialog,OrganizationalStructure},
  data() {
    return {
 
      total:0,
      loading:false,
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        CourseCode:"",
        CourseName:"",
        UpCourseCode:"",
      tableData: [],
      PayItem: [{
          PayItemval: '01',
          PayItemlab: '日常收费'
        },{
          PayItemval: '08',
          PayItemlab: '押金'
        }],
        // 01:日常收费 , 02:停车收费 ,03:装修收费 , 3:进户收费,04:代收费 ,05:代收费,06:其他,07:分等收费，08:押金
        PayItemval: '',
        RevenueItem:[],
       optionsone: [{
          valueone: '选项1',
          labelone: '全部'
        }, {
          valueone: '选项2',
          labelone: '正式员工'
        }, {
          valueone: '选项3',
          labelone: '外包员工'
        }],
        valueone: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      USERList:"",
      ProjectMana:"",
        amount:[],
    }
  },
  methods: {
    menuTool(data){
      if(data == false){
          this.getAllMenu()
      }
    },
      expend(){
          // console.log(this.PayItemval)
      },
    getMsgFormSon(data){
      this.AllData = data
    },
   handleSizeChange(val) {
         this.loading = true
        this.pagesize  = val
        this.getAllMenu()
    },
    handleCurrentChange(val) {
      this.loading = true
        this.currentPage = val
        this.getAllMenu()
    },
    Inquire(){
        // 查询
         this.loading = true
        let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "feeCode":this.CourseCode, // 项目代号
        "feeName":this.CourseName, // 项目名称
        "feeCategory":this.PayItemval,
        // "expendItem":this.PayItemval // 收费项目类别
      }
        this.$http.post(this.$requestUrl.POST_ITEM_LIST,PageSize).then((res) => {
          let data = res.data;
           
          if (200 === data.code) {
              // console.log(data.data.records)
               this.loading = false
                this.total = data.data.total
            this.tableData = data.data.records;
          } else {
            this.$message.error(result.msg)
             this.loading = false
          }
        }).catch(() => {
          this.loading = false
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    getAllMenu() {
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页条数
      }
        this.$http.post(this.$requestUrl.POST_ITEM_LIST,PageSize).then((res) => {
          let data = res.data;
        //   console.log(res)
          if (200 === data.code) {
              this.total = data.data.total
            this.tableData = data.data.records;
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      },
    PropertyAdd(){
        // 添加项目
      this.$refs.ChargeItemDialog.title = "添加";
      this.$refs.ChargeItemDialog.dialogVisible = true; 
      this.$refs.ChargeItemDialog.type = "收款";
      this.$refs.ChargeItemDialog.amount = this.amount
      this.$refs.ChargeItemDialog.finance = this.amount
      this.$refs.ChargeItemDialog.PayItem = this.PayItem
         let obj = {
            "feeCode":"项目代码",
            "feeName":"项目名称",
            "feeCategory":"收费项目类别",
            "displayName":"显示名称",
            "taxRateName":"税额对应科目",
            "subjectsName":"财务对应科目",
            "maintenanceCost":"商品编码",
            "remarks":"备注信息"
          }
          this.$refs.ChargeItemDialog.PayItemval = ""
          this.$refs.ChargeItemDialog.amountval = ""
          this.$refs.ChargeItemDialog.financeval = ""
          let row = {}
          row.obj = obj
          // console.log(row)
         this.$refs.ChargeItemDialog.formLabelAlign= row;
    },
    editMenu(row) { // 修改
    this.$refs.ChargeItemDialog.amount = this.amount
    this.$refs.ChargeItemDialog.finance = this.amount
      this.$refs.ChargeItemDialog.title = "修改";
      this.$refs.ChargeItemDialog.dialogVisible = true; 
      this.$refs.ChargeItemDialog.type = "收款";
      this.$refs.ChargeItemDialog.PayItem = this.PayItem
      this.$refs.ChargeItemDialog.PayItemval = row.feeCategory 
      this.$refs.ChargeItemDialog.amountval = row.taxRateCode
      this.$refs.ChargeItemDialog.financeval = row.subjectsCode
      this.$refs.ChargeItemDialog.subjectslab = row.subjectsName
      this.$refs.ChargeItemDialog.taxRateval = row.taxRateCode
      this.$refs.ChargeItemDialog.taxRatelab = row.taxRateName
            let obj = {
            "feeCode":"项目代码",
            "feeName":"项目名称",
            "feeCategory":"收费项目类别",
            "displayName":"显示名称",
            "taxRateName":"税额对应科目",
            "subjectsName":"财务对应科目",
            "maintenanceCost":"商品编码",
            "remarks":"备注信息"
          }
        row.obj = obj
        // console.log(row)
         this.$refs.ChargeItemDialog.formLabelAlign= row;
        },
        delMenu(row){
            // console.log(row)
             this.$confirm('是否确认要删除该方式?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
    this.$http.post(this.$requestUrl.POST_DELETE_ITEM+"?id="+row.id).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.loading = true
          this.getAllMenu()
             this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }else{
           this.$message({
            type: 'warning',
            message: '删除失败'
          });
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    ItemType(){
        this.$http.get(this.$requestUrl.POST_LIST_ALL).then((res)=>{
           let result = res.data;
        if (200 === result.code) {
            let arr = []
          for(let val of result.data){
            // console.log(val)
              let obj = {
                "PayItemval":val.feeCode,
                "PayItemlab":val.feeName
            }
            arr.push(obj)
          }
          // this.PayItem = arr
        }
        })
    },
    RevenueType(){
          this.$http.get(this.$requestUrl.GET_CHARGE_LIST).then((res)=>{
           let result = res.data;
        if (200 === result.code) {
          this.RevenueTypeone(result.data)
        }
        })
    },
    RevenueTypeone(params){
       var result = [];
                for (let val of params) {
                  if(val.parentCode == null || val.parentCode == ""){
                    var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }
                    parent.children = this.RevenueTypeTwo(val.subjectsCode,params)
                    result.push(parent);
                  }
                  if(val.parentCode == "0"){
                     var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }

                    result.push(parent)
                  }
                  if(val.parentCode == "1"){

                        var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }

                    result.push(parent)
                  }
                  if(val.parentCode == "600110"){  
                          var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }

                    result.push(parent)
                  }
                  if(val.parentCode == "29290"){
                        var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }

                    result.push(parent)
                  }
                  if(val.parentCode == "10802"){
                        var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }

                    result.push(parent)
                  }
                  // console.log(result)
                  this.amount = result
    }
  },
      RevenueTypeTwo(id,array){
        let childs = new Array();
        for(let arr of array){
          if (arr.parentCode == id) {
           childs.push({
               'label': arr.subjectsName,
               'value': arr.subjectsCode,
               'type':arr.parentCode,
           });
          }
        }
         return childs;
    },
  },
  mounted() {
      this.RevenueType()
      this.ItemType()
      this.getAllMenu();
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
.el-cascader-node__label{
  color: black;
}
</style>